import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const heroTitle = document.querySelector(".hero-title");
  if (!heroTitle) return;

  // Preserve inner HTML (so <br> tags stay)
  const originalHTML = heroTitle.innerHTML;

  // Split text while keeping <br> tags
  const splitHTML = originalHTML
    .replace(/<br\s*\/?>/gi, "§") // temporarily replace <br> with a marker
    .split("") // split into characters
    .map((char) => {
      if (char === "§") return "<br>"; // restore <br>
      if (char === " ") return `<span class="space">&nbsp;</span>`;
      return `<span>${char}</span>`;
    })
    .join("");

  heroTitle.innerHTML = splitHTML;

  const letters = heroTitle.querySelectorAll("span");

  // Animate letters (fade + blur + rise)
  gsap.fromTo(
    letters,
    {
      opacity: 0,
      y: 100,
      filter: "blur(10px)",
    },
    {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 2,
      ease: "power3.out",
      stagger: 0.1,
    }
  );

  // Animate subtext (optional)
  const heroSub = document.querySelector(".hero-subtext");
  if (heroSub) {
    gsap.fromTo(
      heroSub,
      { opacity: 0, y: 20, filter: "blur(5px)" },
      {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 2,
        delay: 1.2,
        ease: "power3.out",
      }
    );
  }

  const heroimage = document.querySelector(".hero-image-wrapper");
  if (heroimage) {
    gsap.fromTo(
      heroimage,
      { opacity: 0, top: 80, filter: "blur(5px)" },
      {
        opacity: 1,
        top: 47,
        filter: "blur(0px)",
        duration: 2,
        delay: 1.2,
        ease: "power3.out",
      }
    );
  }
});
